<svg
  width="7"
  height="11"
  viewBox="0 0 7 11"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M0.263924 6.13547L4.91124 10.7317C5.08239 10.9106 5.2961 11 5.55281 11C5.80952 11 6.02323 10.9105 6.19438 10.7317L6.7361 10.2021C6.91197 10.028 6.9999 9.81626 6.9999 9.56679C6.9999 9.32205 6.91199 9.10782 6.7361 8.9243L3.27191 5.49997L6.73625 2.0686C6.91207 1.89443 7 1.68272 7 1.43323C7 1.18851 6.91209 0.974208 6.73625 0.790766L6.19448 0.26124C6.01864 0.0870713 5.8047 -1.04497e-07 5.55291 -1.26509e-07C5.30102 -1.4853e-07 5.08713 0.0870713 4.91134 0.26124L0.263924 4.85751C0.0880084 5.04107 2.53844e-08 5.25525 3.98811e-09 5.5C-2.52902e-05 5.74947 0.0880084 5.9613 0.263924 6.13547Z" />
</svg>
